
<template>
  <!-- Loader displayed when isLoading is true -->
  <div
      v-if="showLoader"
      class="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50"
  >
    <svg
        class="animate-spin h-16 w-16 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
    >
      <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
          fill="none"
      />
    </svg>
  </div>
  <div v-else>
    <div class="relative overflow-x-auto shadow-md sm:rounded-sm mt-5">
      <table class="w-full text-left rtl:text-right text-gray-700">
        <thead>
        <tr class="bg-gray-100">
          <th
              v-for="(header, index) in tableHeaders"
              :key="index"
              scope="col"
              class="px-6 py-3"
          >
            <div class="flex items-center">
              {{ header }}
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
          <tr
              v-for="(item, index) in systemBills"
              :key="index"
              class="border-b"
          >
            <td class="px-6 py-2">{{ index + 1 }}</td>
            <td class="px-6 py-2">{{ item.code }}</td>
            <td class="px-6 py-2">{{ item.month }}</td>
            <td class="px-6 py-2">{{ item.total_amount }}</td>
            <td class="px-6 py-2">{{ item.status }}</td>
            <td class="px-6 py-2">
              {{ item.created_at }}
            </td>
            <td class="px-6 py-2">
                <button
                    @click.prevent="initiatePayment(item.total_amount, item.id)"
                    class="btn-xs bg-custom-blue text-white px-4 py-1 rounded flex items-center gap-1"
                >
                  Pay
                </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
    <PaginationComponent
        v-model:currentPage="currentPage"
        v-model:itemsPerPage="itemsPerPage"
        :totalPages="totalPages"
        :totalItems="totalItems"
        @update:currentPage="goToPage"
        @update:changePageSize="changePageSize"
    />

  <SystemBillingPaymentModal :show="showPaymentModal" :amount="amount" :facilityBillId="selectedBillId" @close="closePaymentModal"/>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import apiClient from "@/services/api";
import {useToast} from "vue-toast-notification";
import PaginationComponent from "@/components/shared/pagination.vue";
import SystemBillingPaymentModal from "@/views/modals/system-billing/SystemBillingPaymentModal.vue";

const showPaymentModal = ref(false);
const selectedBillId = ref(null);
const amount = ref(0);
const showLoader = ref(false);
const systemBills =  ref([]);
const toast = useToast();
const currentPage = ref(1);
const itemsPerPage = ref(10);
const tableHeaders = [
    'No',
    'Code',
    'Month',
    'Total Amount',
    'Status',
    'Created At',
    'Action'
];


const goToPage = (pageNumber) => {
  console.log("goToPage", pageNumber);
  currentPage.value = pageNumber;
  fetchSystemBillingList();
};

const changePageSize = (pageSize) => {
  console.log("change page size", pageSize);
  itemsPerPage.value = pageSize;
  fetchSystemBillingList();
};

const fetchSystemBillingList = async () => {
  try {
    let response = await apiClient.fetchFacilitySystemBills({
      page: currentPage.value,
      itemsPerPage: itemsPerPage.value
    });
    if (response.success) {
      systemBills.value = response.data;
    } else {
      console.error("Failed to fetch system billing list:", response.message);
      toast.error(response.message);
    }
  }catch (e) {
    console.error("Failed to fetch system billing list:", e);
    toast.error("Failed to fetch system billing list");
  }
}

const initiatePayment = (paymentAmount, billId) => {
  showPaymentModal.value = true;
  amount.value = paymentAmount;
  selectedBillId.value = billId;
}

const closePaymentModal = () => {
  showPaymentModal.value = false;
  amount.value = 0;
  selectedBillId.value = null;
}

onMounted(() => {
  fetchSystemBillingList();
});

</script>

<style scoped>

</style>